module.exports = __webpack_public_path__ + "img/eating-burger.79051e9a.png";